// import React from "react";
// import { RiGolfBallLine } from "react-icons/ri";
// import bannerVideo from "../assets/videos/banner_video.mp4";
// import { Link } from "react-router-dom";
// const HeroSection = () => {
//   return (
//     <section className="relative md:h-[calc(100vh-130px)] bg-black text-white pt-28 pb-20 overflow-hidden">
//       <video
//         autoPlay
//         loop
//         muted
//         playsInline
//         className="absolute inset-0 w-full h-full object-cover"
//       >
//         <source src={bannerVideo} type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>

//       <div className="relative z-10 container mx-auto px-6 md:px-12 flex flex-col items-center md:items-start text-center md:text-left space-y-6">
//         <p className="uppercase tracking-widest text-lime-400 font-semibold flex items-center space-x-2">
//           <span>
//             <RiGolfBallLine className="bg-yellow-100 rounded-[50px]" />
//           </span>
//           <span>Welcome to Rangpur Golf & Country Club.</span>
//         </p>
//         <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
//           Where excellence meets <br /> passion on every green
//         </h1>
//         <Link
//           to="/membership"
//           className="relative group overflow-hidden bg-lime-400 text-black font-bold py-3 px-6 rounded-full flex items-center space-x-2 transition-colors duration-500"
//         >
//           {/* Curtain overlay */}
//           <span className="absolute inset-0 bg-black origin-bottom-left scale-x-0 group-hover:scale-x-100 transition-transform duration-700 ease-in-out z-0"></span>

//           {/* Text & Icon (above curtain) */}
//           <span className="relative z-10 flex items-center space-x-2 group-hover:text-white transition-colors duration-500">
//             <span className="uppercase">Get Membership</span>
//             <svg
//               className="w-5 h-5"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2}
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M9 5l7 7-7 7"
//               />
//             </svg>
//           </span>
//         </Link>
//         <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
//           A premier destination for the discerning golfer
//         </h2>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;

// import React from "react";
// import { RiGolfBallLine } from "react-icons/ri";
// import { Sparkles, ArrowRight, Flag, Star, Trophy, MapPin } from "lucide-react";
// import bannerVideo from "../assets/videos/banner_video.mp4";
// import { Link } from "react-router-dom";

// const HeroSection = () => {
//   return (
//     <section className="relative min-h-screen bg-black text-white overflow-hidden">
//       {/* Video Background */}
//       <div className="absolute inset-0">
//         <video
//           autoPlay
//           loop
//           muted
//           playsInline
//           className="absolute inset-0 w-full h-full object-cover"
//         >
//           <source src={bannerVideo} type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//         {/* Gradient Overlay */}
//         <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-emerald-900/60 to-lime-900/40"></div>
//       </div>

//       {/* Floating Decorative Elements */}
//       <div className="absolute inset-0 overflow-hidden pointer-events-none">
//         <div className="absolute top-20 left-10 animate-float">
//           <div className="w-8 h-8 rounded-full bg-gradient-to-r from-emerald-400/20 to-lime-400/20 backdrop-blur-sm border border-emerald-400/30"></div>
//         </div>
//         <div className="absolute top-40 right-20 animate-float-delayed">
//           <div className="w-6 h-6 rounded-full bg-gradient-to-r from-lime-400/20 to-emerald-400/20 backdrop-blur-sm border border-lime-400/30"></div>
//         </div>
//         <div className="absolute bottom-40 left-20 animate-float-slow">
//           <div className="w-10 h-10 rounded-full bg-gradient-to-r from-emerald-400/20 to-lime-400/20 backdrop-blur-sm border border-emerald-400/30"></div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="relative z-10 container mx-auto px-4 md:px-8 min-h-screen flex flex-col justify-center">
//         <div className="max-w-6xl mx-auto">
//           {/* Welcome Badge */}
//           <div className="inline-flex items-center gap-3 mb-8 px-6 py-3 rounded-full bg-gradient-to-r from-emerald-500/20 to-lime-500/20 backdrop-blur-sm border border-emerald-400/30">
//             <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-500 to-lime-500 flex items-center justify-center">
//               <RiGolfBallLine className="w-5 h-5 text-white" />
//             </div>
//             <span className="text-lg font-semibold text-emerald-200 tracking-wider">
//               WELCOME TO RANGPUR GOLF & COUNTRY CLUB
//             </span>
//           </div>

//           {/* Main Heading */}
//           <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold leading-tight mb-8">
//             Where{" "}
//             <span className="relative inline-block">
//               <span className="relative z-10 bg-gradient-to-r from-emerald-300 via-lime-300 to-emerald-300 bg-clip-text text-transparent">
//                 Excellence
//               </span>
//               <span className="absolute bottom-3 left-0 w-full h-4 bg-gradient-to-r from-emerald-500/30 to-lime-500/30 -rotate-1"></span>
//             </span>{" "}
//             Meets Passion
//             <br />
//             <span className="text-4xl md:text-6xl lg:text-7xl text-emerald-100">
//               on Every Green
//             </span>
//           </h1>

//           {/* Sub Heading */}
//           <h2 className="text-2xl md:text-3xl lg:text-4xl text-emerald-100 mb-12 max-w-3xl leading-relaxed">
//             A premier destination for the discerning golfer
//           </h2>

//           {/* Action Buttons */}
//           <div className="flex flex-col sm:flex-row gap-6 mb-16">
//             <Link
//               to="/membership"
//               className="group relative px-10 py-5 rounded-full bg-gradient-to-r from-emerald-500 to-lime-500 text-black font-bold overflow-hidden transition-all duration-500 hover:scale-105 shadow-2xl hover:shadow-3xl"
//             >
//               <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//               <span className="relative z-10 flex items-center justify-center gap-3 text-lg">
//                 <span className="uppercase tracking-wider">Get Membership</span>
//                 <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
//               </span>
//             </Link>

//             <Link
//               to="/golf-course"
//               className="group px-10 py-5 rounded-full border-2 border-emerald-400 text-emerald-300 font-bold hover:bg-emerald-400/10 hover:scale-105 transition-all duration-500 shadow-lg hover:shadow-xl"
//             >
//               <span className="flex items-center justify-center gap-3">
//                 <Flag className="w-5 h-5" />
//                 <span>Explore Course</span>
//               </span>
//             </Link>
//           </div>

//           {/* Features Grid */}
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//             <div className="flex items-center gap-3">
//               <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
//                 <Star className="w-5 h-5 text-emerald-300" />
//               </div>
//               <div>
//                 <div className="text-xl font-bold">9-Hole</div>
//                 <div className="text-sm text-emerald-200">Championship</div>
//               </div>
//             </div>
//             <div className="flex items-center gap-3">
//               <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
//                 <Trophy className="w-5 h-5 text-emerald-300" />
//               </div>
//               <div>
//                 <div className="text-xl font-bold">70+</div>
//                 <div className="text-sm text-emerald-200">Tournaments</div>
//               </div>
//             </div>
//             <div className="flex items-center gap-3">
//               <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
//                 <MapPin className="w-5 h-5 text-emerald-300" />
//               </div>
//               <div>
//                 <div className="text-xl font-bold">Riverside</div>
//                 <div className="text-sm text-emerald-200">Location</div>
//               </div>
//             </div>
//             <div className="flex items-center gap-3">
//               <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
//                 <Sparkles className="w-5 h-5 text-emerald-300" />
//               </div>
//               <div>
//                 <div className="text-xl font-bold">Premium</div>
//                 <div className="text-sm text-emerald-200">Amenities</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Scroll Indicator */}
//       <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
//         <div className="w-10 h-16 rounded-full border-2 border-emerald-400/50 flex items-center justify-center">
//           <div className="w-1 h-6 bg-gradient-to-b from-emerald-400 to-lime-400 rounded-full animate-pulse"></div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;

import React from "react";
import { RiGolfBallLine } from "react-icons/ri";
import { Sparkles, ArrowRight, Flag, Star, Trophy, MapPin } from "lucide-react";
import bannerVideo from "../assets/videos/banner_video.mp4";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="relative h-[78vh] md:h-[80vh] bg-black text-white overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={bannerVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* Gradient Overlay */}
        {/* <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-emerald-900/60 to-lime-900/40"></div> */}
      </div>

      {/* Floating Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-8 animate-float">
          <div className="w-6 h-6 rounded-full bg-gradient-to-r from-emerald-400/20 to-lime-400/20 backdrop-blur-sm border border-emerald-400/30"></div>
        </div>
        <div className="absolute top-20 right-12 animate-float-delayed">
          <div className="w-5 h-5 rounded-full bg-gradient-to-r from-lime-400/20 to-emerald-400/20 backdrop-blur-sm border border-lime-400/30"></div>
        </div>
        <div className="absolute bottom-20 left-16 animate-float-slow">
          <div className="w-8 h-8 rounded-full bg-gradient-to-r from-emerald-400/20 to-lime-400/20 backdrop-blur-sm border border-emerald-400/30"></div>
        </div>
      </div>

      {/* Main Content - Centered with more compact layout */}
      <div className="relative z-10 h-full flex items-center justify-center px-4 md:px-8">
        <div className="max-w-6xl w-full text-center md:text-left">
          {/* Welcome Badge - Smaller */}
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full bg-gradient-to-r from-emerald-500/20 to-lime-500/20 backdrop-blur-sm border border-emerald-400/30">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-emerald-500 to-lime-500 flex items-center justify-center">
              <RiGolfBallLine className="w-4 h-4 text-white" />
            </div>
            <span className="text-sm font-semibold text-emerald-200 tracking-wide">
              WELCOME TO RGCC
            </span>
          </div>

          {/* Main Heading - Adjusted sizes */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6">
            Where{" "}
            <span className="relative inline-block">
              <span className="relative z-10 bg-gradient-to-r from-emerald-300 via-lime-300 to-emerald-300 bg-clip-text text-transparent">
                Excellence
              </span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-500/30 to-lime-500/30 -rotate-1"></span> */}
            </span>{" "}
            Meets Passion
            <br />
            <span className="text-3xl md:text-5xl lg:text-6xl text-emerald-100">
              on Every Green
            </span>
          </h1>

          {/* Sub Heading - Smaller */}
          <h2 className="text-xl md:text-2xl text-emerald-100 mb-8 max-w-2xl mx-auto md:mx-0 leading-relaxed">
            A premier destination for the discerning golfers
          </h2>

          {/* Action Buttons - Smaller padding */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10 justify-center md:justify-start">
            <Link
              to="/membership"
              className="group relative px-8 py-4 rounded-full bg-gradient-to-r from-emerald-500 to-lime-500 text-black font-bold overflow-hidden transition-all duration-500 hover:scale-105 shadow-xl hover:shadow-2xl"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <span className="relative z-10 flex items-center justify-center gap-2 text-base">
                <span className="uppercase tracking-wide">Get Membership</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
              </span>
            </Link>

            <Link
              to="/golf-course"
              className="group px-8 py-4 rounded-full border-2 border-emerald-400 text-emerald-300 font-bold hover:bg-emerald-400/10 hover:scale-105 transition-all duration-500 shadow-lg hover:shadow-xl"
            >
              <span className="flex items-center justify-center gap-2">
                <Flag className="w-4 h-4" />
                <span>Explore Course</span>
              </span>
            </Link>
          </div>

          {/* Features Grid - More compact */}
          {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto md:mx-0">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
                <Star className="w-4 h-4 text-emerald-300" />
              </div>
              <div>
                <div className="text-lg font-bold">9-Hole</div>
                <div className="text-xs text-emerald-200">Championship</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
                <Trophy className="w-4 h-4 text-emerald-300" />
              </div>
              <div>
                <div className="text-lg font-bold">70+</div>
                <div className="text-xs text-emerald-200">Tournaments</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
                <MapPin className="w-4 h-4 text-emerald-300" />
              </div>
              <div>
                <div className="text-lg font-bold">Riverside</div>
                <div className="text-xs text-emerald-200">Location</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-emerald-300" />
              </div>
              <div>
                <div className="text-lg font-bold">Premium</div>
                <div className="text-xs text-emerald-200">Amenities</div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {/* Scroll Indicator - Smaller */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 rounded-full border-2 border-emerald-400/30 flex items-center justify-center">
          <div className="w-1 h-4 bg-gradient-to-b from-emerald-400 to-lime-400 rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
